import { fetchAuthSession } from "aws-amplify/auth";
import { includes } from "lodash";

import { API_MAIN, API_LUKE, API_NODE_SERVER } from "../constants/api";

export const fetchGet = async (uri, api = API_MAIN) => {
  return await fetchRes("GET", uri, api);
};

export const fetchGetAbort = async (uri, signal, api = API_MAIN) => {
  return await fetchResAbort("GET", uri, signal, api);
}

export const fetchPost = (uri, body, api = API_MAIN) => {
  return fetchRes("POST", uri, api, body);
};

export const fetchPostError = (uri, body, api = API_MAIN) => {
  return fetchResError("POST", uri, api, body);
};

export const fetchPostAbort = (uri, body, signal, api = API_MAIN) => {
  return fetchResAbort("POST", uri, api, signal, body);
}

export const fetchPut = (uri, body, api = API_MAIN) => {
  return fetchRes("PUT", uri, api, body);
};

export const fetchPatch = (uri, body, api = API_MAIN) => {
  return fetchRes("PATCH", uri, api, body);
};

export const fetchDelete = (uri, body = {}, api = API_MAIN) => {
  return fetchRes("DELETE", uri, api, body);
};

const fetchRes = async (method, uri, api, body) => {
  try {
    var headers;
    if (uri === "ds/self_sign_up") {
      headers = await getHeaders2(api, uri);
    } else {
      headers = await getHeaders(api, uri);
    }
    let res = await fetch(`/${api}/${uri}`, {
      method,
      headers,
      body: JSON.stringify(body),
      timeout: 30 * 1000,
    });
    if (res.status === 200 || res.status === 202 || res.status === 201) {
      if (
        res.headers &&
        res.headers.get("content-type").indexOf("application/json") !== -1
      ) {
        res = await res.json();
      }
      if (
        res.headers &&
        (res.headers.get("content-type").indexOf("image/jpeg") !== -1 || res.headers.get("content-type").indexOf("image/png") !== -1)
      ) {
        let buffer = await res.arrayBuffer();
        let base64Flag = "data:image/jpeg;base64,";
        let imageStr = arrayBufferToBase64(buffer);
        res = base64Flag + imageStr;
      }
      if (
        res.headers &&
        res.headers.get("content-type").indexOf("audio/ogg") !== -1
      ) {
        res = await res.arrayBuffer();
      }
      return res;
    } else {

      throw new Error("API call failed.");
    }
  } catch (e) {
    console.log("Fetch", e);
    throw e;
  }
};

const fetchResAbort = async (method, uri, api, signal, body) => {
  try {
    var headers;
    if (uri === "ds/self_sign_up") {
      headers = await getHeaders2(api, uri);
    } else {
      headers = await getHeaders(api, uri);
    }
    let res = await fetch(`/${api}/${uri}`, {
      method,
      headers,
      body: JSON.stringify(body),
      timeout: 30 * 1000,
      signal: signal,
    });
    if (res.status === 200 || res.status === 202 || res.status === 201) {
      if (
        res.headers &&
        res.headers.get("content-type").indexOf("application/json") !== -1
      ) {
        res = await res.json();
      }
      if (
        res.headers &&
        (res.headers.get("content-type").indexOf("image/jpeg") !== -1 || res.headers.get("content-type").indexOf("image/png") !== -1)
      ) {
        let buffer = await res.arrayBuffer();
        let base64Flag = "data:image/jpeg;base64,";
        let imageStr = arrayBufferToBase64(buffer);
        res = base64Flag + imageStr;
      }
      if (
        res.headers &&
        res.headers.get("content-type").indexOf("audio/ogg") !== -1
      ) {
        res = await res.arrayBuffer();
      }
      return res;
    } else {

      throw new Error("API call failed.");
    }
  } catch (e) {
    if (!signal.aborted) {
      console.log("Fetch", e);
    }
    throw e;
  }
};

const fetchResError = async (method, uri, api, body) => {
  try {
    var headers;
    if (uri === "ds/self_sign_up") {
      headers = await getHeaders2(api, uri);
    } else {
      headers = await getHeaders(api, uri);
    }
    let res = await fetch(`/${api}/${uri}`, {
      method,
      headers,
      body: JSON.stringify(body),
      timeout: 30 * 1000,
    });
    if (res.status === 200 || res.status === 202 || res.status === 201) {
      if (
        res.headers &&
        res.headers.get("content-type").indexOf("application/json") !== -1
      ) {
        res = await res.json();
      }
      if (
        res.headers &&
        (res.headers.get("content-type").indexOf("image/jpeg") !== -1 || res.headers.get("content-type").indexOf("image/png") !== -1)
      ) {
        let buffer = await res.arrayBuffer();
        let base64Flag = "data:image/jpeg;base64,";
        let imageStr = arrayBufferToBase64(buffer);
        res = base64Flag + imageStr;
      }
      if (
        res.headers &&
        res.headers.get("content-type").indexOf("audio/ogg") !== -1
      ) {
        res = await res.arrayBuffer();
      }
      return res;
    } else {
      return res;
    }
  } catch (e) {
    console.log("Fetch", e);
    throw e;
  }
};

const getHeaders2 = async (api, uri) => {
  let headers = {
    "Content-Type": "application/json",
  };

  if (includes(uri, "audio/")) {
    headers["Content-Type"] = "audio/ogg";
    headers["Accept"] = "audio/ogg";
    console.log(headers);
  }
  if (includes(uri, "policies/")) {
    headers["Content-Type"] = "application/pdf";
    headers["Accept"] = "application/pdf";
  }
  if (!includes([API_LUKE, API_NODE_SERVER], api)) {
    let jwtToken = "";
    try {
      headers["Authorization"] = jwtToken;
    } catch (error) {
      console.log("error:", error);
      throw error;
    }
  }
  return headers;
};

const getHeaders = async (api, uri) => {
  let headers = {
    "Content-Type": "application/json",
  };

  if (includes(uri, "audio/")) {
    headers["Content-Type"] = "audio/ogg";
    headers["Accept"] = "audio/ogg";
    console.log(headers);
  }
  if (includes(uri, "policies/")) {
    headers["Content-Type"] = "application/pdf";
    headers["Accept"] = "application/pdf";
  }
  if (!includes([API_LUKE, API_NODE_SERVER], api)) {
    let jwtToken = "";
    try {
      const session = await fetchAuthSession();
      jwtToken = session?.tokens?.idToken?.toString?.() || "";
      headers["Authorization"] = jwtToken;
    } catch (error) {
      console.log("error:", error);
      throw error;
    }
  }
  return headers;
};

const arrayBufferToBase64 = (buffer) => {
  let binary = "";
  let bytes = [].slice.call(new Uint8Array(buffer));
  bytes.forEach((b) => (binary += String.fromCharCode(b)));
  return window.btoa(binary);
};
